import { UTAG_URL, UTAG_EMULATION_URL } from '../config';

/**
 * Load Tealium (utag.js) file on demand
 *
 * @param {Record<number, 0 | 1>} consents categories -> numeric boolean for
 * what categories have been opted out
 * @returns {Promise<void>} A promise that resolves when the script has loaded
 * @public
 */
export function loadUtag(consents) {
  // If utag.js has already been loaded, return a resolve promise
  if (window.utag) return Promise.resolve();

  // Otherwise, return a promise that will resolve once the script is loaded
  return new Promise((resolve, reject) => {
    const scripts = window.ux && window.ux.privacy && window.ux.privacy.scripts || {
      0: [
        window.ux &&
        window.ux.privacy &&
        window.ux.privacy.emulateUtag ?
          UTAG_EMULATION_URL :
          UTAG_URL
      ]
    };
    for (const [category, hrefs] of Object.entries(scripts)) {
      if (consents[category] !== 1) {
        for (const href of hrefs) {
          try {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = href;
            script.onload = resolve;
            document.head.appendChild(script);
          } catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            reject(err);
          }
        }
      }
    }
  });
}

/**
 * viewUtag function will load utag.js and export utag object to window.
 *
 * @param {Record<number, 0 | 1>} consents categories -> numeric boolean for
 * what categories have been opted out
 * @public
 */
export async function viewUtag(consents) {
  try {
    // With awaits, this code waits for the promise to resolve
    // If rejected, it will throw and go into catch
    await loadUtag(consents);

    window.utag.view(window.utag.data);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}
